import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import Tabs, { Tab, TabList, TabPanel } from "@atlaskit/tabs";
import { SelectedType } from "@atlaskit/tabs/dist/types/types";
import { token } from "@atlaskit/tokens";

type AISummaryTabsProps = {
    answerPanel: React.ReactNode;
    sourcesPanel: React.ReactNode;
    selected?: SelectedType;
    onChange?: (index: SelectedType) => void;
};

export const AISummaryTabs = ({
    answerPanel,
    sourcesPanel,
    selected,
    onChange
}: AISummaryTabsProps) => {
    const intl = useIntl();
    const answerText = intl.formatMessage({
        id: "ai.summary.tabs.answer",
        defaultMessage: "AI Answer"
    });
    const sourcesText = intl.formatMessage({
        id: "ai.summary.tabs.sources",
        defaultMessage: "Sources"
    });

    return (
        <Tabs id="ai-summary-tabs" selected={selected} onChange={onChange}>
            <TabList>
                <Tab>
                    <div css={tabStyle}>{answerText}</div>
                </Tab>
                {sourcesPanel && (
                    <Tab>
                        <div css={tabStyle}>{sourcesText}</div>
                    </Tab>
                )}
            </TabList>
            <TabPanel>
                <div css={panelStyle}>
                    <span>{answerPanel}</span>
                </div>
            </TabPanel>
            {sourcesPanel && (
                <TabPanel>
                    <div css={panelStyle}>
                        <span>{sourcesPanel}</span>
                    </div>
                </TabPanel>
            )}
        </Tabs>
    );
};

const tabStyle = css({
    textAlign: "center",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Charlie Text",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400 !important",
    lineHeight: "24px",
    display: "flex",
    padding: "0px 8px 8px 8px",
    gap: token("space.050")
});

const panelStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: token("space.025"),
    width: "100%",
    paddingBlockStart: "16px"
});
